import { render, staticRenderFns } from "./SearchStudent.vue?vue&type=template&id=23c4eb84&scoped=true&"
import script from "./SearchStudent.vue?vue&type=script&lang=js&"
export * from "./SearchStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4eb84",
  null
  
)

export default component.exports